
        import Symbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-webmap-display",
  "use": "icon-webmap-display-usage",
  "viewBox": "0 0 6.35 6.35",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6.35 6.35\" id=\"icon-webmap-display\"><path d=\"M3.525 2.243v-.489l.814-.652v1.063h.548c-.002-.556.003-1.113-.003-1.67C4.861.26 4.537.188 4.392.36l-1.134.911c-.411-.323-.813-.66-1.23-.974-.232-.113-.402.119-.57.239-.376.307-.762.601-1.13.916-.105.18-.044.4-.06.6C.27 3.19.264 4.328.27 5.465c.027.236.346.314.491.136.448-.366.907-.718 1.348-1.092.115-.192.029-.428.07-.64.07-.75.622-1.416 1.345-1.626M1.63 4.207l-.814.652V1.754l.814-.652Zm3.57.606c.418-.588.237-1.484-.369-1.873-.572-.409-1.442-.26-1.848.315-.434.552-.333 1.43.225 1.862.442.374 1.132.416 1.608.081l.886.887.384-.384zm-1.127.072c-.512.019-.934-.526-.788-1.019.11-.498.736-.773 1.176-.513.456.227.571.9.215 1.265a.81.81 0 0 1-.603.267\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-webmap-display"/>
                </svg>
            );
        };

        Icon.id = "icon-webmap-display";

        export default Icon;
    